import { mainSiteUrl } from '@/mocks/categories';

export default function ShippingSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              Shipping Guide
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Understand Basetao Shipping Cost
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              Master the factors that affect your international shipping expenses and learn how to optimize every shipment
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 mb-10">
            {[
              { icon: 'ri-weight-line', title: 'Package Weight', desc: 'The single biggest cost driver. Heavier parcels cost more across all carriers. Consolidate wisely.' },
              { icon: 'ri-map-pin-line', title: 'Destination Country', desc: 'Shipping to the USA, UK, Canada, and Australia each has different rate structures and transit times.' },
              { icon: 'ri-ship-line', title: 'Shipping Method', desc: 'Express (DHL/FedEx) is fast but pricey. Economy lines save money but take longer. Balance speed vs cost.' },
              { icon: 'ri-building-line', title: 'Warehouse Handling', desc: 'Consolidation, repacking, and value-added services affect the final shipping invoice.' },
            ].map((item) => (
              <div key={item.title} className="text-center p-5 bg-background-100 rounded-lg border border-background-200/60">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Use Our Shipping Calculator <i className="ri-calculator-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}